import { Outlet, Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from "react";
import { navMenus } from "./menu"; 

import { useContext } from 'react';
import { ArgContext } from "../../Context/ArgProvider";


export default function SubMenu() {
  const location = useLocation();
  const pathname = location.pathname;

  //관리자 메뉴
  const { argInfo } = useContext(ArgContext);
  const isAdmin = argInfo?.role === 'admin';

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const [isDepth1Open, setIsDepth1Open] = useState(false);
  const [isDepth2Open, setIsDepth2Open] = useState(false);

 

  // 현재 메뉴 그룹 찾기
  const currentGroup = navMenus.find(menu => {
    if (menu.groups) {
      // groups 구조인 경우 각 그룹의 children을 확인
      return menu.groups.some(group => 
        group.children.some(child => pathname.includes(child.path))
      );
    } else if (menu.children) {
      return menu.children.some(sub => pathname.includes(sub.path));
    }
    return pathname.includes(menu.path);
  });

  const currentDepth1 = currentGroup?.title || '';
  
  // currentDepth2 찾기 - groups와 children 모두 처리
  let currentDepth2 = '';
  if (currentGroup?.groups) {
    // groups 구조인 경우 현재 경로에 해당하는 항목 찾기
    for (const group of currentGroup.groups) {
      const foundChild = group.children.find(child => pathname.includes(child.path));
      if (foundChild) {
        currentDepth2 = foundChild.title;
        break;
      }
    }
  } else if (currentGroup?.children) {
    currentDepth2 = currentGroup.children.find(sub => pathname.includes(sub.path))?.title || '';
  }

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setIsDepth1Open(false);
    setIsDepth2Open(false);
  }, [pathname]);

  return (
    <div className="sub-menuWrap">
      <Link to="/" className="homeBtn">홈</Link>

      {/* Depth 1 */}
      <div className={`menu-select menu-depth01  ${(isMobile && isDepth1Open) ? 'active' : ''}`}
        onMouseEnter={() => !isMobile && setIsDepth1Open(true)}
        onMouseLeave={() => !isMobile && setIsDepth1Open(false)}

      >
        <p className="select" onClick={() => {
            setIsDepth1Open(prev => !prev);
            setIsDepth2Open(false); // depth2 닫기
          }}>
          {currentDepth1 || '메뉴 선택'}
        </p>
        {isDepth1Open && (
          <ul className="menu-list">
            {navMenus.map(menu => {
              // groups 구조인 경우 첫 번째 그룹의 첫 번째 children의 path 사용
              const firstPath = menu.groups?.[0]?.children?.[0]?.path || 
                               menu.children?.[0]?.path || 
                               menu.path;
              return (
                <li key={menu.title}
                  className={currentGroup?.title === menu.title ? 'on' : ''}
                >
                  <Link
                    to={firstPath}
                    className="nav-list"
                    onClick={() => setIsDepth1Open(false)}
                  >
                    {menu.title}
                  </Link>
                </li>
              );
            })}
          </ul>
        )}
      </div>

      {/* Depth 2 */}
      {(currentGroup?.children || currentGroup?.groups) && (
        <div className={`menu-select menu-depth02 ${(isMobile && isDepth2Open) ? 'active' : ''}`}
        onMouseEnter={() => !isMobile && setIsDepth2Open(true)}
        onMouseLeave={() => !isMobile && setIsDepth2Open(false)}
        >
          <p className="select" onClick={() => {
              setIsDepth2Open(prev => !prev);
              setIsDepth1Open(false); // depth1 닫기
            }}
>
            {currentDepth2 || '세부 메뉴'}
          </p>
          {isDepth2Open && (
            <ul className="menu-list">
              {currentGroup.groups ? (
                // groups 구조인 경우 모든 그룹의 children을 평면화
                currentGroup.groups.flatMap(group => 
                  group.children
                    .filter(sub => {
                      // '회사연혁 리스트'는 관리자만 보이게
                      if (sub.title === '회사연혁 리스트') {
                        return isAdmin;
                      }
                      return true;
                    })
                    .map(sub => (
                      <li key={sub.path}
                      className={pathname.includes(sub.path) ? 'on' : ''}
                      >
                        <Link
                          to={sub.path}
                          className="nav-list"
                          onClick={() => setIsDepth2Open(false)}
                        >
                          {sub.title}
                        </Link>
                      </li>
                    ))
                )
              ) : (
                // 기존 children 구조
                currentGroup.children
                  .filter(sub => {
                    // '회사연혁 리스트'는 관리자만 보이게
                    if (sub.title === '회사연혁 리스트') {
                      return isAdmin;
                    }
                    return true;
                  })
                  .map(sub => (
                    <li key={sub.path}
                    className={pathname.includes(sub.path) ? 'on' : ''}
                    >
                      <Link
                        to={sub.path}
                        className="nav-list"
                        onClick={() => setIsDepth2Open(false)}
                      >
                        {sub.title}
                      </Link>
                    </li>
                  ))
              )}
            </ul>
          )}
        </div>
      )}

      {/* 하단 콘텐츠 */}
      <div className="sub-contentWrap">
        <Outlet />
      </div>
    </div>

  );
}
